import { IBaseModel } from "./abstract/ibaseModel.interface";
import { Customer } from "./customer.model";
import { Hub } from "./hub.model";
import { Ward } from "./ward.model";
import { ShipmentStatus } from "./shipmentStatus.model";
import { LadingSchesule } from "./ladingSchedule.model";
import { Package, Reason, Province, PriceDVGT } from "./index";
import { Size } from "./size.model";
import { User } from "./user.model";
import { Service } from "./service.model";
import { PaymentType } from "./paymentType.model";
import { Structure } from "./structure.model";
import { ReasonService } from "../services/index";
import { Boxes } from "./boxes.model";
import { TPL } from "./tpl.model";
import { ListGoods } from "./listGoods.model";
import { District } from "./district.model";
import { CusDepartment } from "./cusDepartment.model";
import { ShipmentContract } from "./shipmentContract.model";
import { PromotionDetail } from "./promotionDetail.moddel";
import { ShipmentSendSMS } from "./shipmentSendSMS.model"
import { from } from "rxjs";
import { ListPriceByShipmentId } from "./listPriceByShipmentId.model";

export class Shipment implements IBaseModel {
    id: number;
    concurrencyStamp: string
    isEnabled: boolean;
    shipmentNumber: string;
    shopCode: string;
    disCount: number = 0;
    orderDate: any;
    endOrderDate: any;
    deliveryDate: any;
    endPickTime: any;
    startPickTime?: any;
    sellerId?: number;
    sellerName?: string;
    sellerPhone: string;
    senderId?: number = null;
    senderName: string;
    senderPhone: string;
    companyFrom: string;
    addressNoteFrom: string;
    pickingAddress: string;
    latFrom: number;
    lngFrom: number;
    fromStreetId?: number;
    fromWardId?: number;
    fromDistrictId?: number;
    fromProvinceId?: number;
    fromHubId?: number;
    fromHubRoutingId?: number;
    receiverCode: string;
    receiverName: string;
    receiverPhone: string;
    companyTo: string;
    addressNoteTo: string;
    shippingAddress: string;
    latTo: number;
    lngTo: number;
    toWardId?: number;
    toDistrictId?: number;
    toProvinceId?: number;
    toHubId?: number;
    toHubRoutingId?: number;
    serviceId?: number;
    paymentTypeId: number;
    thirdPLId?: number;
    pickUserId?: number;
    checkUserId?: number;
    checkUserName: string;
    deliverUserId?: number;
    transactionHistoryId?: number
    numDeliver?: number;
    transferUserId?: number;
    transferUser?: any;
    transferReturnUserId?: number;
    returnUserId?: number;
    note: string;
    weight: number = 0;
    weights: number = 0;
    length: number;
    height: number;
    width: number;
    calWeight: number = 0;
    excWeight?: number = 0;
    shipmentStatusId: number;
    shipmentStatusIds: number[] = [];
    cusNote: string;
    content: string;
    totalBox: number;
    doc?: number = 0;
    currentEmpId: number;
    keepingTotalPriceEmpId?: number;
    keepingTotalPriceHubId?: number;
    keepingCODEmpId?: number;
    keepingCODHubId?: number;
    isPaidPrice: boolean;
    requestShipmentId?: number;
    packageId?: number;
    receiveHubId?: number;
    currentHubId: number;
    cod: number;
    insured: number;
    defaultPrice: number = 0;
    isAgreementPrice: boolean;
    isCreditTransfer: boolean;
    remoteAreasPrice: number;
    fuelPrice: number;
    totalDVGT: number;
    otherPrice: number;
    vatPrice: number;
    totalPrice: number = 0;
    totalPrices: number = 0;
    totalPricesT: string;
    paymentMethodId?: number = 1;

    structureId: number;
    serviceDVGTIds: number[] = [];
    strServiceDVGTIds?: string;
    strServiceDVGTName?: string;
    listGoodsId?: number;
    provinceCode?: string;
    deliveryImagePath?: string[];
    deliveryImages?: string[];
    firstDeliveredTime?: any;
    parrentShipmentNumber?: string;
    childShipmentNumbers?: string;
    shipmentTypeName?: string;
    senderCode?: string;
    isAllowDebit?: boolean;
    //
    currentLat: number;
    currentLng: number;
    location: string;
    //
    tplId?: number;
    tpl?: TPL;
    tplNumber?: string;
    tplCreatedWhen?: any;

    package?: Package;
    requestShipment?: Shipment;
    parentShipment?: Shipment;
    sender?: Customer;
    receiver?: Customer;
    fromHub?: Hub;
    fromHubRouting?: Hub;
    toHub?: Hub;
    toHubRouting?: Hub;
    fromWard?: Ward;
    toWard?: Ward;
    receiveHub?: Hub;
    currentHub?: Hub;
    currentEmp?: User;
    deliverUser?: User;
    pickUser?: User;
    businessUser?: User;
    returnUser?: User;
    shipmentStatus?: ShipmentStatus;
    paymentType?: PaymentType;
    ladingSchedules?: LadingSchesule[];
    fromProvince?: Province;
    toProvince?: Province;
    toDistrict?: District;
    service?: Service;
    size?: Size;
    structure?: Structure;
    serviceDVGT?: Service;
    shipmentServiceDVGTs?: Service[];
    serviceDVGTIdsCode?: string;
    //
    //dateRangeValue: any = new Object();
    reasonService?: ReasonService;
    reason?: Reason;
    boxes?: Shipment[] = [];
    //assign pickup
    assignPickTime?: Date;
    listGoods?: ListGoods;
    //EXCEL
    requestCode?: string;
    staffCode?: string;
    customerCode?: string;
    structureCode?: string;
    serviceCode?: string;
    serviceDVGTCode?: string;
    paymentTypeCode?: string;
    assignedPickupMinutes?: number;
    assignedPickupHours?: number;
    //assing delivery
    assignDeliveryTime?: Date;
    assignedDeliveyMinutes?: number;
    assignedDeliveyHours?: number;
    endDeliveryTime?: any;
    //RealRecipientName
    realRecipientName: string;
    key?: number;
    isValid?: boolean;
    message?: string;
    isExistVersion?: boolean;
    fromHubName?: string;
    toHubName?: string;
    // shipment support
    totalShipment?: number;
    shipmentId?: any;
    shipmentIds?: any[] = [];
    chargeWeight?: number;
    // department
    cusDepartmentId?: number;
    CusDepartment?: CusDepartment;
    // return
    isReturn: boolean;
    pickupImagePath?: string;
    reasonId: number;
    // change ShippingAddress
    defaultShippingAddress?: string;
    isChangeShippingAddress?: boolean;
    totalItem: number = 0;
    countShipmentAccept?: number;
    totalShipmentNotFill?: number;
    priceDVGTs: PriceDVGT[] = [];
    // process error
    isProcessError?: boolean;
    processErrorTime?: any;
    priceListId?: number;
    //
    totalChildRequestShipment?: number;
    totalChildShipment?: number;
    // shipment canceled
    createdWhen?: any;
    deletedShipmentAt?: any;
    userCode?: string;
    userFullName?: string;
    userHubName?: string;
    paymentTypeName?: string;
    serviceName?: string;
    deliverUserName?: string;
    fromProvinceName?: string;
    fromHubRoutingName?: string;
    toProvinceName?: string;
    toDistrictName?: string;
    toWardName?: string;
    toHubRoutingName?: string;
    typeId?: number;
    handlingEmpId?: number;
    // ghi log dữ liệu thay đổi
    dataChanged?: string;
    // tpl
    tplPrice?: number;
    tplCurrentId?: number;
    tplPriceReal?: number;
    tplTransitListGoodsId?: number;
    isTPLTransit?: boolean;
    //
    listCustomerPaymentCODId?: number;
    listCustomerPaymentTotalPriceId?: number;
    deliveryNote?: string;
    //
    paymentCODTypeId?: number = null;
    receiverId?: number;
    businessUserId?: number;
    priceReturn: number;
    priceCOD: number;
    pricePTN: number
    totalPriceSYS: number = 0;
    //
    isBox: boolean;
    isCreatedChild: boolean;
    isPaymentChild: boolean;
    isPrioritize: boolean;
    defaultPriceS: number;
    defaultPriceP: number;
    //
    deliveryAppointmentTime?: any;
    expectedDeliveryTime?: any;
    expectedDeliveryTimeSystem?: any;
    pickupAppointmentTime?: any;
    endReturnTime?: any;
    //
    isTruckDelivery: boolean = false;
    typeRider: any;
    //
    isQua4Tieng?: boolean;
    isTooLate?: boolean;
    totalCount?: number = 0;
    reasonName: string;
    //
    kmNumberTW: number;
    KmNumberTD: number;
    //
    distance: number;
    receiverCode2: string;
    isPickupWH: boolean;
    isDeliveryWH: boolean;
    //
    payCOD: number;
    payPriceCOD: number;
    payTotalPrice: number;
    sumPayCOD: number;
    sumPayPriceCOD: number;
    sumPayTotalPrice: number;
    //
    inputUserFullName?: string;
    outputUserFullName?: string;
    //
    toHubRoutingEmp?: string;
    //
    totalShipmentInPackage?: number;
    totalPackage?: number;
    totalBoxs?: number;
    //
    fullName?: string;
    kmNumber: number;
    receiptCODCode: string;
    receiptPriceCode: string;
    timeCompare?: number;
    // 
    totalPricePay?: number;
    returnReason: string;
    deliveryWhenOne?: any;
    deliveryReasonOne: string;
    deliveryWhenTwo?: any;
    deliveryReasonTwo: string;
    deliveryWhenThree?: any;
    deliveryReasonThree: string;
    receiptCODCreatedWhen?: any;
    countImageDelivery?: number;
    //    
    addressNew?: string;
    sumInsured?: number;
    sumCOD?: number;
    sumPriceCOD?: number;
    sumTotalPrice?: number;
    sumTotalPricePay?: number;
    tplCode?: string;
    tplName?: string;
    shipmentBoxs?: Shipment[] = [];
    cloneShipmentBoxs?: Shipment[] = [];
    totalPriceNoChange: number;
    totalPriceXTotalBoxNoChange: number;
    //
    usingPriceService: any;
    usingPriceServicePlus: any;
    isEditPriceDVGT: any;
    //
    list_package: any;
    transferVehicleId: number;
    pickupVehicleId: number;
    pickupVehicleName: string;
    deliveryVehicleId: number;
    deliveryVehicleName: number;
    numberOfDeliveries: number = 1;
    isDeliveryPlace: boolean;
    //
    boxTypeID: any
    boxName: any
    percentPickupSuccess: any
    structureName: any
    currentHubName: any
    shipmentNumberS: string
    shipmentNumberW: any;
    boxTypeName: string
    //
    contactUs: string;
    isContact: boolean;
    isNotExist: boolean;
    shipmentContract: ShipmentContract = new ShipmentContract();

    isBulky: boolean;
    pickTruckId: number;
    pickTruckNumber: string;

    swTime: number = 0;
    totalShipment_rowSpan: number = 0;
    index_rowSpan: number = 0;
    shipmentBoxIds: any[] = [];
    shipmentBoxMerges: Shipment[];
    shipmentBoxDeletes: any[];
    totalGTN: number;
    isNew: boolean = false;
    needPapers: boolean = false;
    needPhoneNumber: boolean = false;
    pers: boolean = false;
    createdHubId: number;
    userUpdate: number;
    userCreatedName: string;
    promotionCode: string;
    promotionPrice: number;
    totalPriceRound: number = 0;
    originalPrice: number = 0;
    pricePayment: number;
    promotionId: number[] = [];
    promotionDetail: PromotionDetail[] = [];
    isDVGTGTN: boolean;
    isLo: boolean;
    totalItemTF: number = 0;
    shipmentContactId?: number;
    totalItemInListGood: number;
    totalWeight: number = 0;
    totalUnload: number = 0;
    shipmentSendSMS: ShipmentSendSMS[] = [];
    listShipmentNumberW: any[];
    stringShipmentNumberW: string;
    isExpan: boolean = false;
    totalPriceSaveWareHouse: number = 0;
    empNote: string;

    totalPriceCR: number;
    totalPriceCC: number;
    priceLTN: number;
    priceGTN: number;
    priceGTNPS: number;
    priceBX: number;
    pricePPK: number;
    priceLK: number;
    totalPriceDVGT: number;
    totalPricePayment: number;
    shipmentContractTypeId?: number;
    contractId?: number;
    isShipmentContract?: boolean;
    deposits: number = 0;

    userUpdateName: string;
    listBoxs: any[] = [];

    serviceCNNG: number[] = [];
    listPriceDetail: ListPriceByShipmentId[] = [];
    shipmentContractTypeName: string;
    transactionTypeId?: number;
    shipmentContractNumber: string;
    vehicleName: string;
    route: string;
    vat: number;
    totalLK: number;
    addressToFull: string;
    promotionDeliveryCode: any;
    timePrint: any
    parentShipmentId?: number;
    isCreateInvoice: boolean;
    isCustomerNumberId: boolean;
    imageCheckId: any;
    isPlus: boolean;
    isWarning: boolean; // cảnh báo kiện hàng trong trung chuyển, chuyển hàng, xuống hàng
    currentListGoodCode: any;
    //
    truckNumber: string;
    empUnloadName: string;
    driverName: string;
}
